import { router } from 'expo-router';
import React, { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { Box, Text } from '@fhs-legacy/universal-components';
import ActionButton from 'components/action-button';
import LoadingAnimation from 'components/loading-animation';
import UserVerificationModal from 'components/user-verification-modal';
import { useAuthContext } from 'state/auth';

const Container = Box.withConfig({
  width: 'full',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
});

const StyledText = Text.withConfig({
  marginTop: '$3',
  marginBottom: '$3',
});

interface IVerifyEmailMessageProps {
  redirectUrl?: string;
  showModalOnLoad?: boolean;
}

const VerifyEmailMessage = ({ redirectUrl, showModalOnLoad = false }: IVerifyEmailMessageProps) => {
  const { formatMessage } = useIntl();
  const { refreshCurrentUser } = useAuthContext();
  const [showingSpinner, setShowingSpinner] = useState(true);
  const [showVerificationModal, setShowVerificationModal] = useState(showModalOnLoad);
  const handleModalDismiss = useCallback(() => {
    if (redirectUrl) {
      router.navigate(redirectUrl);
    } else {
      setShowVerificationModal(false);
    }
  }, [redirectUrl]);
  useEffect(() => {
    const refreshUser = async () => {
      try {
        await refreshCurrentUser();
      } finally {
        setShowingSpinner(false);
      }
    };
    refreshUser();
  }, [refreshCurrentUser]);

  const handleVerifyPress = useCallback(() => {
    setShowVerificationModal(true);
  }, []);
  
  return (
    <>
      <Container testID="verify-email-banner">
        <StyledText>{formatMessage({ id: 'pleaseVerifyEmail' })}</StyledText>
        {showingSpinner ? (
          <LoadingAnimation size={"sm"} />
        ) : (
          <ActionButton testID="verify-email-link" onPress={handleVerifyPress}>
            {formatMessage({ id: 'verify' })}
          </ActionButton>
        )}
      </Container>
      {showVerificationModal && <UserVerificationModal showDialog onDismiss={handleModalDismiss} />}
    </>
  );
};

export default VerifyEmailMessage;
